<template>
  <el-container>
    <el-main class="bg-white" v-if="reviewForm.visible">
      <el-page-header
        @back="reviewForm.visible = false"
        class="question-page-header"
      >
        <template v-slot:content>
          <div>详情页面</div>
          <el-button
            v-if="reviewForm.type !== 'question' && !list[0].id && isReady"
            size="mini"
            type="text"
            plain
            @click="handlePush"
            >提交</el-button
          >
        </template>
      </el-page-header>
      <answer-layer
        v-if="reviewForm.type === 'question'"
        class="mt-5"
        v-bind="reviewForm.params"
        @save="updateProgress"
        @change-type="handleStart('scene')"
      />
      <scene-layer
        v-else
        class="mt-5"
        v-bind="reviewForm.params"
        @save="updateSceneProgress"
        @change-type="reviewForm.visible = false"
      />
    </el-main>
    <el-main class="bg-white" v-else-if="ownerForm.visible">
      <el-page-header
        @back="ownerForm.visible = false"
        class="question-page-header"
      >
        <template v-slot:content>
          <div>详情页面</div>
          <el-button
            v-if="
              ownerForm.type !== 'question' &&
              (!list[1].declarationId || list[1].declarationStatus !== 0) &&
              isOwnerReady
            "
            size="mini"
            type="text"
            plain
            @click="handleOwnerPush"
            >提交</el-button
          >
        </template>
      </el-page-header>
      <owner-answer-layer
        v-if="ownerForm.type === 'question'"
        class="mt-5"
        v-bind="ownerForm.params"
        @save="updateOwnerProgress"
        @change-type="handleOwnerStart('scene')"
      />
      <owner-scene-layer
        v-else
        class="mt-5"
        v-bind="ownerForm.params"
        @save="updateOwnerSceneProgress"
        @change-type="ownerForm.visible = false"
      />
    </el-main>
    <el-main v-else>
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ backgroundColor: '#eaeaea' }"
      >
        <el-table-column align="center" label="序号" type="index" />
        <el-table-column
          align="center"
          label="问卷名称"
          prop="name"
          width="400"
        >
          <template v-slot="scope">
            <p v-html="scope.row.name"></p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="问卷详情"
          prop="desc"
          width="400"
        />
        <el-table-column
          align="center"
          label="问卷进度"
          prop="questionProgress"
        >
          <template v-slot="scope">
            <template v-if="scope.$index === 0">
              <el-button type="text" plain @click="handleStart('question')">{{
                scope.row.declarationStatus === 2
                  ? "查看问卷"
                  : `${scope.row.quesProgress}/${scope.row.quesLength}`
              }}</el-button>
            </template>
            <template v-else>
              <span>{{
                `${scope.row.quesProgress}/${scope.row.quesLength}`
              }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="场景进度" prop="sceneProgress">
          <template v-slot="scope">
            <template v-if="scope.$index === 0">
              <el-button type="text" plain @click="handleStart('scene')">{{
                scope.row.declarationStatus === 2
                  ? "查看场景"
                  : `${scope.row.sceneProgress}/${scope.row.sceneLength}`
              }}</el-button>
            </template>
            <template v-else>
              <span>{{
                `${scope.row.sceneProgress}/${scope.row.sceneLength}`
              }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="status">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
          <template v-slot="scope">
            <template v-if="scope.$index === 0">
              <template v-if="!scope.row.id">
                <el-button
                  type="text"
                  size="mini"
                  plain
                  @click="handleStart('question')"
                  >答卷</el-button
                >
                <el-button
                  v-if="isReady"
                  type="text"
                  size="mini"
                  plain
                  @click="handlePush"
                  >提交</el-button
                >
              </template>
              <template v-else>
                <!-- <el-button
                  type="text"
                  plain
                  size="mini"
                  @click="handleReport(scope.row)"
                  >自评报告</el-button
                > -->
                <el-button
                  v-if="scope.row.issue * 1 && false"
                  type="text"
                  plain
                  size="mini"
                  @click="handleReview(scope.row)"
                  >查看报告</el-button
                >
                <template v-if="scope.row.declarationStatus === 1">
                  <el-button
                    type="text"
                    plain
                    size="mini"
                    @click="handleStart('question')"
                    >修改</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    plain
                    @click="handlePushFix"
                    >提交</el-button
                  >
                </template>
              </template>
            </template>
            <template v-else>
              <template v-if="!scope.row.declarationId">
                <el-button
                  v-if="
                    scope.row.quesProgress > 0 || scope.row.sceneProgress > 0
                  "
                  type="text"
                  size="mini"
                  plain
                  @click="handleOwnerStart('question')"
                  >继续答卷</el-button
                >
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  plain
                  @click="handleOwnerStart('question')"
                  >答卷</el-button
                >
                <el-button
                  v-if="isOwnerReady"
                  type="text"
                  size="mini"
                  plain
                  @click="handleOwnerPush"
                  >提交</el-button
                >
              </template>
              <template v-else>
                <el-button
                  v-if="scope.row.declarationStatus === 0"
                  type="text"
                  size="mini"
                  plain
                  @click="handleOwnerReset"
                  >重新答卷</el-button
                >
                <template v-else>
                  <el-button
                    v-if="
                      scope.row.quesProgress > 0 || scope.row.sceneProgress > 0
                    "
                    type="text"
                    size="mini"
                    plain
                    @click="handleOwnerStart('question')"
                    >继续答卷</el-button
                  >
                  <el-button
                    v-else
                    type="text"
                    size="mini"
                    plain
                    @click="handleOwnerStart('question')"
                    >重新答卷</el-button
                  >
                </template>
                <el-button
                  v-if="isOwnerReady && scope.row.declarationStatus !== 0"
                  type="text"
                  size="mini"
                  plain
                  @click="handleOwnerPush"
                  >提交</el-button
                >
                <el-button
                  type="text"
                  plain
                  size="mini"
                  @click="handleOwnerReport(scope.row)"
                  >自评报告</el-button
                >
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      v-if="ownerDatePopForm.visible"
      title="修改评测时间"
      visible
      :show-close="true"
      :append-to-body="true"
      @close="ownerDatePopForm.visible = false"
    >
      <el-container>
        <el-main>
          <el-form
            ref="datePopForm"
            label-width="100px"
            :model="ownerDatePopForm.params"
            :rules="datePopRules"
            size="mini"
          >
            <el-form-item label="评测日期" prop="date">
              <el-date-picker
                type="date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                v-model="ownerDatePopForm.params.date"
                placeholder="请选择评测时间"
              />
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ownerDatePopForm.visible = false">取消</el-button>
        <el-button type="primary" @click="handleOwnerAddDate">确定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import AnswerLayer from "@/views/proposal/partials/answer-layer";
import OwnerAnswerLayer from "@/views/proposal/partials/owner-answer-layer";
import SceneLayer from "@/views/proposal/partials/scene-layer";
import OwnerSceneLayer from "@/views/proposal/partials/owner-scene-layer";
import {
  addDeclaration,
  addOwnerDeclaration,
  fixDeclaration,
  getAnswerList,
  getAnswerPivot,
  getDeclaration,
  getEvaluate,
  getManagerReport,
  getOwnerAnswer,
  getOwnerDeclaration,
  getOwnerSceneAnswer,
  getSceneAnswer,
  getScenes,
  resetOwnerDeclaration,
} from "@/api/enterprise";
import { mapGetters } from "vuex";

export default {
  components: { AnswerLayer, OwnerAnswerLayer, SceneLayer, OwnerSceneLayer },
  data() {
    return {
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      list: [
        {
          id: 0,
          name: '中小企业数字化水平<span class="text-blue-500">第三方评测</span>',
          desc: "1、数字化基础、管理及成效；2、数字化经营应用场景",
          status: "未开始",
          quesAnswers: [],
          sceneAnswers: [],
          quesAllAnswers: [],
          sceneAllAnswers: [],
          declarationStatus: null,
          quesProgress: 0,
          sceneProgress: 0,
          quesLength: 15,
          sceneLength: 16,
          ready: false,
          pivots: [],
        },
        {
          id: 0,
          declarationId: null,
          name: '中小企业数字化水平<span class="text-red-500">自评测</span>',
          desc: "通过答题获取自评测报告",
          status: "未开始",
          declarationStatus: null,
          quesProgress: 0,
          sceneProgress: 0,
          quesLength: 15,
          sceneLength: 16,
          ready: false,
        },
      ],
      evaluate: [],
      evaluateScenes: [],
      reviewForm: {
        visible: false,
        type: "question",
        params: {},
      },
      ownerForm: {
        visible: false,
        type: "question",
        params: {},
      },
      ownerDatePopForm: {
        visible: false,
        params: {
          date: null,
        },
      },
      datePopRules: {
        date: { required: true, message: "评测日期不能为空", trigger: "blur" },
      },
    };
  },
  computed: {
    ...mapGetters(["staff"]),
    isReady() {
      return this.list[0].id
        ? this.list[0].ready
        : this.list[0].quesAnswers.length >= 15;
    },
    isOwnerReady() {
      return this.list[1].quesProgress >= 15;
    },
  },
  mounted() {
    Promise.all([this.loadQuestions(), this.loadScenes()]).then(() => {
      this.loadData();
      this.loadOwnerData();
    });
  },
  methods: {
    loadOwnerData() {
      this.loading = true;
      return Promise.all([
        getOwnerDeclaration(this.staff.id).then((res) => res.data || {}),
        getOwnerAnswer(this.staff.id).then((res) => res.data || []),
        getOwnerSceneAnswer(this.staff.id).then((res) =>
          (res.data || []).sort((a, b) => (a.quesId * 1 > b.quesId ? 1 : -1))
        ),
      ])
        .then((data) => {
          if (data[0].id) {
            const status =
              data[0].declarationStatus === 0 ? "已出报告" : "答卷中";
            Object.assign(
              this.list[1],
              data[0],
              calcOwnerAnswers(data[1], data[2], data[0]),
              { id: 0, declarationId: data[0].id },
              { status }
            );
            Object.assign(this.list[1], {
              questions: makeQuestions(this.evaluate),
              questionTree: makeQuestionTree(this.evaluate),
              scenes: makeScenes(this.evaluateScenes),
              sceneTree: makeSceneTree(this.evaluateScenes),
            });
          } else {
            Object.assign(this.list[1], data[0], {
              id: 0,
              declarationId: data[0].id,
              quesAnswers: data[1],
              sceneAnswers: data[2],
              quesAllAnswers: data[1],
              sceneAllAnswers: data[2],
              quesProgress: data[1].length,
              sceneProgress: data[2].length,
              ready: false,
              questions: makeQuestions(this.evaluate),
              questionTree: makeQuestionTree(this.evaluate),
              scenes: makeScenes(this.evaluateScenes),
              sceneTree: makeSceneTree(this.evaluateScenes),
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadData() {
      this.loading = true;
      Promise.all([
        getDeclaration(this.staff.id).then((res) => {
          return res.data || {};
        }),
        getAnswerList({ userId: this.staff.id }).then((res) => {
          return res.data || [];
        }),
        getSceneAnswer({ userId: this.staff.id }).then((res) => {
          return res.data || [];
        }),
        getAnswerPivot({ userId: this.staff.id }).then((res) => {
          return res.data || [];
        }),
      ])
        .then((data) => {
          if (data[0].id) {
            const status =
              data[0].declarationStatus === 0
                ? "待审核"
                : data[0].declarationStatus === 2
                ? "已完成"
                : "待修改";
            Object.assign(
              this.list[0],
              data[0],
              calcAnswers(data[1], data[2], data[3], data[0]),
              { status }
            );
            Object.assign(
              this.list[0],
              buildQuestionTree(this.evaluate, this.list[0].quesAnswers),
              buildSceneTree(this.evaluateScenes, this.list[0].sceneAnswers)
            );
          } else {
            const status =
              data[1].length || data[2].length ? "答卷中" : "未开始";
            Object.assign(this.list[0], {
              quesAnswers: data[1],
              sceneAnswers: data[2],
              quesAllAnswers: data[1],
              sceneAllAnswers: data[2],
              quesProgress: data[1].length,
              sceneProgress: data[2].length,
              quesLength: 15,
              sceneLength: 16,
              ready: false,
              pivots: [],
              status,
            });
            Object.assign(this.list[0], {
              questions: makeQuestions(this.evaluate),
              questionTree: makeQuestionTree(this.evaluate),
              scenes: makeScenes(this.evaluateScenes),
              sceneTree: makeSceneTree(this.evaluateScenes),
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadQuestions() {
      return getEvaluate({ pId: 0, treeLink: "0;", version: 1 }).then((res) => {
        this.evaluate = res.data;
      });
    },
    loadScenes() {
      return getScenes({ pId: 0, treeLink: "0;", version: 1 }).then((res) => {
        this.evaluateScenes = res.data;
      });
    },
    handleStart(type) {
      const info = Object.assign({ userId: this.staff.id }, this.list[0]);
      Object.assign(this.reviewForm, {
        visible: true,
        type,
        row: this.list[0],
        params:
          type === "question"
            ? {
                info,
                questions: info.questions,
                answers: info.quesAnswers,
                all: info.quesAllAnswers,
                tree: info.questionTree,
                isView: info.id && info.declarationStatus !== 1,
                role: "enterprise",
                mode: "view",
              }
            : {
                info,
                questions: info.scenes,
                answers: info.sceneAnswers,
                all: info.sceneAllAnswers,
                tree: info.sceneTree,
                isView: info.id && info.declarationStatus !== 1,
                role: "enterprise",
                mode: "view",
              },
      });
    },
    handleOwnerStart(type) {
      const info = Object.assign({ userId: this.staff.id }, this.list[1]);
      Object.assign(this.ownerForm, {
        visible: true,
        type,
        row: this.list[1],
        params:
          type === "question"
            ? {
                info,
                questions: info.questions,
                answers: info.quesAnswers,
                all: info.quesAllAnswers,
                tree: info.questionTree,
                isView: info.declarationId && info.declarationStatus === 0,
                role: "enterprise",
                mode: "view",
              }
            : {
                info,
                questions: info.scenes,
                answers: info.sceneAnswers,
                all: info.sceneAllAnswers,
                tree: info.sceneTree,
                isView: info.declarationId && info.declarationStatus === 0,
                role: "enterprise",
                mode: "view",
              },
      });
    },
    handlePushFix() {
      this.loading = true;
      (this.isReady
        ? Promise.resolve()
        : this.$confirm(
            this.isReady
              ? "还有未处理的专家意见，是否忽略意见直接提交?"
              : "提交问卷后不可再修改选项，确定提交吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
      )
        .then(() => {
          fixDeclaration({ declarationStatus: 0 }).then(() => {
            this.loadData();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handlePush() {
      if (!this.isReady) {
        this.$confirm(
          "数字化基础、管理及成效还有题未作答，请答完后再提交!",
          "提示",
          {
            confirmButtonText: "确定",
            showCancelButton: false,
          }
        );
      } else {
        this.loading = true;
        this.$confirm(
          `已完成${this.list[0].sceneAnswers.length}个场景，提交问卷后不可再修改选项，确定提交吗?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            addDeclaration({ declarationStatus: 0 }).then(() => {
              this.loadData();
              Object.assign(this.reviewForm.params, { isView: true });
            });
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleOwnerPush() {
      if (!this.isOwnerReady) {
        this.$confirm(
          "数字化基础、管理及成效还有题未作答，请答完后再提交!",
          "提示",
          {
            confirmButtonText: "确定",
            showCancelButton: false,
          }
        );
      } else {
        this.$confirm(
          `已完成${this.list[1].sceneProgress}个场景，提交问卷后不可再修改选项，确定提交吗?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          const now = new Date();
          const date = `${now.getFullYear()}-${(now.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}`;
          Object.assign(this.ownerDatePopForm, {
            visible: true,
            params: {
              date,
            },
          });
        });
      }
    },
    handleOwnerAddDate() {
      this.$refs.datePopForm.validate((valid) => {
        if (valid) {
          this.handleOwnerPushWithDate(this.ownerDatePopForm.params.date);
          this.ownerDatePopForm.visible = false;
        }
      });
    },
    handleOwnerPushWithDate(date) {
      this.loading = true;
      addOwnerDeclaration({ declarationStatus: 0, createAt: date })
        .then(() => {
          this.loadOwnerData();
          Object.assign(this.ownerForm, { visible: false });
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleOwnerReset() {
      this.loading = true;
      resetOwnerDeclaration()
        .then(() => {
          return this.loadOwnerData();
        })
        .then(() => {
          this.handleOwnerStart("question");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateProgress() {
      getAnswerList({ userId: this.staff.id }).then((res) => {
        if (this.list[0].id) {
          Object.assign(
            this.list[0],
            calcAnswers(
              res.data || [],
              this.list[0].sceneAllAnswers,
              this.list[0].pivots,
              this.list[0],
              this.permissionList
            )
          );
          Object.assign(this.reviewForm.params, {
            answers: this.list[0].quesAnswers,
            all: this.list[0].quesAllAnswers,
          });
        } else {
          this.$set(this.list[0], "quesProgress", res.data.length);
          this.list[0].quesAnswers = res.data;
          if (this.list[0].status === "未开始") {
            this.list[0].status = "答卷中";
          }
        }
      });
    },
    updateOwnerProgress() {
      getOwnerAnswer(this.staff.id).then((res) => {
        if (this.list[1].declarationId) {
          Object.assign(
            this.list[1],
            calcOwnerAnswers(
              res.data || [],
              this.list[1].sceneAllAnswers,
              this.list[1]
            )
          );
          Object.assign(this.ownerForm.params, {
            answers: this.list[1].quesAnswers,
            all: this.list[1].quesAllAnswers,
          });
        } else {
          this.$set(this.list[1], "quesProgress", res.data.length);
          this.list[1].quesAnswers = res.data;
          if (this.list[1].status === "未开始") {
            this.list[1].status = "答卷中";
          }
        }
      });
    },
    updateSceneProgress() {
      getSceneAnswer({ userId: this.staff.id }).then((res) => {
        if (this.list[0].id) {
          Object.assign(
            this.list[0],
            calcAnswers(
              this.list[0].quesAllAnswers,
              res.data || [],
              this.list[0].pivots,
              this.list[0],
              this.permissionList
            )
          );
          Object.assign(this.reviewForm.params, {
            answers: this.list[0].sceneAnswers,
            all: this.list[0].sceneAllAnswers,
          });
        } else {
          this.$set(this.list[0], "sceneProgress", res.data.length);
          this.list[0].sceneAnswers = res.data;
          if (this.list[0].status === "未开始") {
            this.list[0].status = "答卷中";
          }
        }
      });
    },
    updateOwnerSceneProgress() {
      getOwnerSceneAnswer(this.staff.id).then((res) => {
        if (this.list[1].declarationId) {
          Object.assign(
            this.list[1],
            calcOwnerAnswers(
              this.list[1].quesAllAnswers,
              res.data || [],
              this.list[1]
            )
          );
          Object.assign(this.ownerForm.params, {
            answers: this.list[1].sceneAnswers,
            all: this.list[1].sceneAllAnswers,
          });
        } else {
          this.$set(this.list[1], "sceneProgress", res.data.length);
          this.list[1].sceneAnswers = res.data;
          if (this.list[1].status === "未开始") {
            this.list[1].status = "答卷中";
          }
        }
      });
    },
    handleReport() {
      const win = window.open("/letter-report", "letter-report");
      const handleMessage = ({ data }) => {
        data === "getLetterReport" &&
          win &&
          win.postMessage(JSON.stringify(this.list[0]));
      };

      window.addEventListener("message", handleMessage);
    },
    handleOwnerReport() {
      const win = window.open("/letter-owner-report", "letter-owner-report");
      const handleMessage = ({ data }) => {
        let json = this.list[1];
        if (this.list[1].declarationStatus !== 0) {
          json = Object.assign(
            {},
            this.list[1],
            calcOwnerAnswers(
              this.list[1].quesAllAnswers,
              this.list[1].sceneAllAnswers,
              Object.assign({}, this.list[1], {
                version: this.list[1].version - 1,
              })
            )
          );
        }
        data === "getLetterOwnerReport" &&
          win &&
          win.postMessage(JSON.stringify(json));
      };

      window.addEventListener("message", handleMessage);
    },
    async handleReview() {
      const res = await getManagerReport(this.staff.id);
      const win = window.open("/enterprise-report", "enterprise-report");
      const handleMessage = ({ data }) => {
        const answer = this.list[0].quesAnswers.find(
          (v) => v.quesId * 1 === 11
        );
        const form = {
          userId: res.data.userId,
          strThree: res.data.strThree,
          strFive: res.data.strFive,
          reportNum: res.data.reportNum,
          reportDate: res.data.reportDate,
          strFour: res.data.strFour,
          p_2_1: res.data.strOne,
          answerArr: [
            null,
            Object.assign({}, answer, {
              otherAns: JSON.parse(answer.otherAns),
            }),
          ],
        };
        data === "getEnterpriseReport" &&
          win &&
          win.postMessage(JSON.stringify(form));
        window.removeEventListener("message", handleMessage);
      };

      window.addEventListener("message", handleMessage);
    },
  },
};

function calcOwnerAnswers(answers, scenes, info) {
  const quesAll = answers.filter((v) => v.version * 1 <= info.version);
  const sceneAll = scenes.filter((v) => v.version * 1 <= info.version);
  const quesCurrent = answers.filter((v) => v.version * 1 === info.version);
  const sceneCurrent = scenes.filter((v) => v.version * 1 === info.version);
  const progress = {
    ques: 0,
    scene: 0,
  };
  progress.ques = quesCurrent.length;
  progress.scene = sceneCurrent.length;

  return {
    quesAnswers: quesCurrent,
    sceneAnswers: sceneCurrent,
    quesAllAnswers: quesAll,
    sceneAllAnswers: sceneAll,
    quesProgress: progress.ques,
    sceneProgress: progress.scene,
    quesLength: 15,
    sceneLength: 16,
    ready:
      progress.ques === quesCurrent.length &&
      progress.scene === sceneCurrent.length,
  };
}

function calcAnswers(answers, scenes, pivot, info) {
  const quesAll = answers
    .filter((v) => v.version * 1 <= info.version)
    .map((v) =>
      Object.assign(v, {
        pivot: pivot.find(
          (p) =>
            p.userId * 1 === v.userId * 1 &&
            p.quesId * 1 === v.quesId * 1 &&
            p.version * 1 === v.version * 1 &&
            p.type === 0
        ),
      })
    );
  const sceneAll = scenes
    .filter((v) => v.version * 1 <= info.version)
    .map((v) =>
      Object.assign(v, {
        pivot: pivot.find(
          (p) =>
            p.userId * 1 === v.userId * 1 &&
            p.quesId * 1 === v.quesId * 1 &&
            p.version * 1 === v.version * 1 &&
            p.type === 1
        ),
      })
    );
  const quesCurrent = answers.filter((v) => v.version * 1 === info.version);
  const sceneCurrent = scenes.filter((v) => v.version * 1 === info.version);
  const progress = {
    ques: 0,
    scene: 0,
  };
  if (info.declarationStatus === 0) {
    progress.ques = quesCurrent.length;
    progress.scene = sceneCurrent.length;
  } else if (info.declarationStatus === 1) {
    progress.ques = quesCurrent.filter(
      (v) =>
        v.status === 1 ||
        quesAll.find(
          (_) =>
            v.quesId * 1 === _.quesId * 1 && _.version * 1 === info.version - 1
        ).pivot.status === 1
    ).length;
    progress.scene = sceneCurrent.filter(
      (v) =>
        v.status === 1 ||
        sceneAll.find(
          (_) =>
            v.quesId * 1 === _.quesId * 1 && _.version * 1 === info.version - 1
        ).pivot.status === 1
    ).length;
  }
  return {
    id: info.id,
    quesAnswers: quesCurrent,
    sceneAnswers: sceneCurrent,
    quesAllAnswers: quesAll,
    sceneAllAnswers: sceneAll,
    quesProgress: progress.ques,
    sceneProgress: progress.scene,
    quesLength: quesCurrent.length,
    sceneLength: sceneCurrent.length,
    ready:
      progress.ques === quesCurrent.length &&
      progress.scene === sceneCurrent.length,
    pivots: pivot,
  };
}

function makeQuestions(evaluate) {
  return evaluate.reduce(
    (obj, item) => {
      obj.cache[item.id] = item;
      item.parent = obj.cache[item.parentId];
      if (item.level === 3) {
        obj.arr.push(item);
      } else if (item.level === 4) {
        obj.cache[item.parentId].question = Object.assign(item, {
          children: [],
        });
        obj.cache[item.parentId].i = item.i;
        delete item.parent;
      } else if (item.level === 5) {
        obj.cache[item.parentId].children.push(item);
        delete item.parent;
      }
      return obj;
    },
    { arr: [], cache: {} }
  ).arr;
}
function makeQuestionTree(evaluate) {
  return evaluate.reduce(
    (obj, item) => {
      obj.cache[item.id] = { label: item.name, level: item.level, id: item.id };
      if (item.level < 4) {
        (obj.cache[item.parentId]
          ? obj.cache[item.parentId].children ??
            (obj.cache[item.parentId].children = [])
          : obj.tree
        ).push(obj.cache[item.id]);
      }
      return obj;
    },
    { tree: [], cache: {} }
  ).tree;
}
function makeScenes(evaluateScenes) {
  return evaluateScenes.reduce(
    (obj, item) => {
      obj.cache[item.id] = item;
      item.parent = obj.cache[item.parentId];
      if (item.level === 2) {
        obj.arr.push(Object.assign(item, { i: obj.arr.length + 1 }));
        item.children = [];
      } else if (item.level === 3) {
        obj.cache[item.parentId].children.push(item);
        delete item.parent;
      }
      return obj;
    },
    { arr: [], cache: {} }
  ).arr;
}
function makeSceneTree(evaluateScenes) {
  return evaluateScenes.reduce(
    (obj, item) => {
      obj.cache[item.id] = { label: item.name, level: item.level, id: item.id };
      if (item.level < 3) {
        (obj.cache[item.parentId]
          ? obj.cache[item.parentId].children ??
            (obj.cache[item.parentId].children = [])
          : obj.tree
        ).push(obj.cache[item.id]);
      }
      return obj;
    },
    { tree: [], cache: {} }
  ).tree;
}

function buildQuestionTree(arr, answers) {
  const questions = arr
    .reduce(
      (obj, item) => {
        const cache = (obj.cache[item.id] = Object.assign({}, item));
        obj.cache[cache.id].parent = obj.cache[cache.parentId];
        if (cache.level === 3) {
          obj.arr.push(
            Object.assign(obj.cache[cache.id], { i: obj.arr.length + 1 })
          );
        } else if (cache.level === 4) {
          obj.cache[cache.parentId].question = Object.assign(
            obj.cache[cache.id],
            { children: [] }
          );
          obj.cache[cache.parentId].ii = obj.cache[cache.id].i;
          delete obj.cache[cache.id].parent;
        } else if (cache.level === 5) {
          obj.cache[cache.parentId].children.push(obj.cache[cache.id]);
          delete obj.cache[cache.id].parent;
        }
        return obj;
      },
      { arr: [], cache: {} }
    )
    .arr.filter((v) => answers.find((a) => a.quesId * 1 === v.question.id));

  const tree = questions.reduce(
    (o, v) => {
      const parent = v.parent;
      const grandpa = parent.parent;
      if (!o.cache[grandpa.id]) {
        o.cache[grandpa.id] = {
          id: grandpa.id,
          name: grandpa.name,
          label: grandpa.name,
          level: grandpa.level,
          children: [],
        };
        o.tree.push(o.cache[grandpa.id]);
      }
      if (!o.cache[parent.id]) {
        o.cache[parent.id] = {
          id: parent.id,
          name: parent.name,
          label: parent.name,
          level: parent.level,
          children: [],
        };
        o.cache[grandpa.id].children.push(o.cache[parent.id]);
      }
      o.cache[parent.id].children.push({
        id: v.id,
        name: v.name,
        label: v.name,
        level: v.level,
      });
      return o;
    },
    { tree: [], cache: {} }
  ).tree;
  return {
    questions,
    questionTree: tree,
  };
}
function buildSceneTree(arr, answers) {
  const scenes = arr
    .reduce(
      (obj, item) => {
        const cache = (obj.cache[item.id] = Object.assign({}, item));
        cache.parent = obj.cache[cache.parentId];
        if (cache.level === 2) {
          obj.arr.push(Object.assign(cache, { i: obj.arr.length + 1 }));
          cache.children = [];
        } else if (cache.level === 3) {
          obj.cache[cache.parentId].children.push(cache);
          delete cache.parent;
        }
        return obj;
      },
      { arr: [], cache: {} }
    )
    .arr.filter((v) => answers.find((a) => a.quesId * 1 === v.id));

  const tree = scenes.reduce(
    (o, v) => {
      const parent = v.parent;
      if (!o.cache[parent.id]) {
        o.cache[parent.id] = {
          id: parent.id,
          name: parent.name,
          label: parent.name,
          level: parent.level,
          children: [],
        };
        o.tree.push(o.cache[parent.id]);
      }
      o.cache[parent.id].children.push({
        id: v.id,
        name: v.name,
        label: v.name,
        level: v.level,
      });

      return o;
    },
    { tree: [], cache: {} }
  ).tree;
  return {
    scenes,
    sceneTree: tree,
  };
}
</script>
